export default {
  name: '(P) Image',
  slug: 'p-image',
  class: 'gf_product-image',
  wrap: 'gf_product-image',
};
